import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../testnurse/service/service.component';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';



@Component({
  selector: 'ivfprintview',
  templateUrl: './ivfprintview.component.html',
  styleUrls: ['./ivfprintview.component.scss']
})

export class IvfPrintviewComponent implements OnInit {
 
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
 

  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting = true;
      this.router.navigate([{ outlets: { print: null } }]);
    });
  }
  isPrinting = false;


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
   

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}


 
 
 



